import React from "react";
import Radio from "antd/lib/radio";
import {
  SurveyQuestionCard,
  SymptomAlertCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface ChestPainSectionProps {
  readonly currentPage: number;
}

export const ChestPainSection: React.FC<ChestPainSectionProps> = ({
  currentPage
}) => {
  return (
    <>
      {currentPage === 8 && (
        <SurveyQuestionCard
          sectionTag="CHEST PAIN"
          title="Have you had any chest pain during dialysis recently?"
          required
        >
          <FormItemStyle
            name="Have you had any chest pain"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={
                localStorage.getItem("haveYouHadAnyChestPain") ||
                sessionStorage.getItem("haveYouHadAnyChestPain") ||
                undefined
              }
              onChange={e => {
                localStorage.setItem("haveYouHadAnyChestPain", e.target.value);
                sessionStorage.setItem(
                  "haveYouHadAnyChestPain",
                  e.target.value
                );
              }}
            >
              <AnswerList>
                <AnswerOption value="None">None</AnswerOption>
                <AnswerOption value="Rarely (1 - 2 / Month)">
                  Rarely (1 - 2 / Month)
                </AnswerOption>
                <AnswerOption value="Occasional (3 - 4 / Month)">
                  Occasional (3 - 4 / Month)
                </AnswerOption>
                <AnswerOption value="Frequent (5 - 10 / Month)">
                  Frequent (5 - 10 / Month)
                </AnswerOption>
                <AnswerOption value="Every dialysis (11 - 13 / Month)">
                  Every dialysis (11 - 13 / Month)
                </AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
      {currentPage === 9 && (
        <SymptomAlertCard message="Please be sure to discuss your symptoms of chest pain with your nurse or doctor" />
      )}
    </>
  );
};
